import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { SuperInfoPause } from "../actions/websocket";
import { showmodalPause } from "../actions";
const { connection_platform } = require("../services/api");

const TimeCounterInternalDash = ({
  horario,
  status,
  max,
  iduser,
  maxTime,
  showmodalpause,
}) => {
  const [time, setTime] = useState(!isNaN(horario) ? horario * 1000 : 0); // Tempo atual
  const [colorText, setColorText] = useState("inherit"); // Cor do texto
  const intervalRef = useRef(null); // Armazena o identificador do intervalo

  useEffect(() => {
    // Inicia o contador ao montar
    const startTime = Date.now() - time;

    intervalRef.current = setInterval(() => {
      setTime(Date.now() - startTime); // Atualiza o tempo decorrido
    }, connection_platform.milliseconds || 1000); // Atualiza a cada segundo

    return () => {
      // Limpa o intervalo ao desmontar
      clearInterval(intervalRef.current);
    };
  }, []); // Executa apenas uma vez ao montar

  useEffect(() => {
    // Verifica se o tempo máximo foi atingido
    if (
      max > 0 &&
      status === "Pausado" &&
      Math.round(Moment.duration(time).asSeconds()) === max
    ) {
      showmodalpause(true); // Mostra o modal
      SuperInfoPause(iduser); // Chama a pausa no Redux
    }
  }, [time, max, status, iduser, showmodalpause]); // Reexecuta ao mudar tempo, max, ou status

  useEffect(() => {
    // Verifica se o tempo excedeu o limite máximo
    if (maxTime > 0) {
      if (time > maxTime) {
        setColorText("#c90000"); // Muda a cor do texto para vermelho
      } else {
        setColorText("inherit"); // Reseta para a cor padrão
      }
    }
  }, [time, maxTime]); // Reexecuta quando o tempo ou maxTime mudam

  // Formata o tempo para exibição
  const formattedTime = Moment.utc(time).format("HH:mm:ss");

  return (
    <span
      style={{
        color: colorText,
        fontSize: "inherit",
      }}
    >
      {formattedTime}
    </span>
  );
};

// Conexão com Redux
const mapDispatchToProps = (dispatch) => ({
  showmodalpause: (params) => dispatch(showmodalPause(params)),
});

export default connect(null, mapDispatchToProps)(TimeCounterInternalDash);
